import { Media } from '../media/Media'
import { Artist } from '../artist/Artist'

export class ProfileArtwork {
  id?: string
  title?: string
  slug?: string
  description?: string = ''
  price?: number
  category_id?: string
  technique_id?: string
  width?: number
  height?: number
  depth?: number
  weight?: number
  vat_rate?: number
  themes?: any[]
  is_visible?: boolean
  is_active?: boolean
  is_framed?: boolean
  is_hang_ready?: boolean
  is_published?: boolean
  isForSale?: boolean // this property is used inside TkArtwork.vue to show sold ribbon
  created_year?: number
  media?: Media[] | Media = undefined
  unhiding?: boolean = false
  cloning?: boolean = false
  deleting?: boolean = false
  dimension?: string
  artist?: Artist
  path?: string
  favorite_id?: string
  my_subscription_id?: string
  keywords?: string[]
  isTestable?: boolean = undefined
  locked_until: string | null = null
  video_id: string | null = null;
  is_video_approved: boolean = false;

  constructor(data: Partial<ProfileArtwork> = {}) {
    Object.assign(this, data)
  }

}
